import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import styles from './Foldable.module.css';
const Foldable = ({ show, className = '', variant = 'complete', height, children, }) => (_jsx("div", { className: clsx({
        [className]: true,
        [styles['partialFoldable']]: variant === 'partial',
        [styles['fullFoldable']]: variant === 'complete',
        [styles['unfolded']]: show,
        [styles['partialFade']]: !show && variant === 'partial',
    }), "aria-hidden": !show, style: {
        // @ts-expect-error CSS variable
        '--foldable-folded-height': height,
    }, children: _jsx("div", { className: clsx(!show && styles['inner']), children: children }) }));
export default Foldable;
//# sourceMappingURL=Foldable.js.map